import { render, staticRenderFns } from "./DealerCreateTickets.vue?vue&type=template&id=068fec04&"
import script from "./DealerCreateTickets.vue?vue&type=script&lang=js&"
export * from "./DealerCreateTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports